module.exports = __webpack_public_path__ + "img/logo-training.c5ad4832.svg";